import React from 'react';
import SectionIncomingConsignment from '../SectionIncomingConsignment';

const ElectricalGoodsInwardConsignment = () => (
  <SectionIncomingConsignment
    sectionName="Electrical Goods"
    sectionDisplayName="Electrical Goods"
    backRoute="/sections/electrical-goods"
  />
);

export default ElectricalGoodsInwardConsignment;
